import { queryKeys } from "../queryKeys";
import {
  getInstantAchEligibility,
  type InstantAchEligibility,
} from "../rest/banking";
import useRequest, { type QueryOptions } from "./useRequest";

type UseGetInstantAchEligibilityProps = {
  accountID: string;
  options?: QueryOptions<InstantAchEligibility>;
};

export const useGetInstantAchEligibility = ({
  accountID,
  options,
}: UseGetInstantAchEligibilityProps) => {
  return useRequest(
    queryKeys.funding.instantAchEligibility(accountID),
    () => getInstantAchEligibility(accountID),
    {
      ...options,
      enabled: !!accountID && (options?.enabled ?? true),
    },
  );
};
